module.exports = __webpack_public_path__ + "img/car1.4f8f77ea.jpg";